import React, { useContext } from "react";
import { ProductContext } from "../../../stores/session";
import GenericDataRow from "../../../GenericPageElements/GenericDataRow";

export default function WholesalerSelect({ data, wholesalers, selectedWholesaler, setSelectedWholesaler }) {
    const { translations, isWorkflow } = useContext(ProductContext)

    return (
        <GenericDataRow
            title={translations['Wholesaler']}
            contentColour={'var(--white)'}
            contentStyle={isWorkflow ? { padding: '0px' } : { backgroundColor: '#ececec', fontSize: '13px' }}
        >
            {
                isWorkflow ?
                    <select
                        style={{ border: 'none', width: '100%', outline: 'none' }}
                        onChange={(event) => setSelectedWholesaler(event.target.value)}
                        value={selectedWholesaler}
                    >
                        <option value=''>All Wholesalers</option>
                        {wholesalers.map(wholesaler => (
                            <option key={wholesaler.value} value={wholesaler.value}>
                                {wholesaler.label}
                            </option>
                        ))}
                    </select>
                    :
                    data.Wholesaler
            }
        </GenericDataRow>
    )
}